import { Button } from '../button/button.js';
import styles from './error-state.module.css';

type ErrorStateProps = {
  title: string;
  message: string;
  onRetry?: () => void;
};

export const ErrorState = ({ title, message, onRetry }: ErrorStateProps) => (
  <div className={styles.errorState}>
    <p className={styles.title}>{title}</p>
    <p className={styles.message}>{message}</p>
    {onRetry !== undefined && (
      <div className={styles.action}>
        <Button variant="secondary" onClick={onRetry}>
          Спробувати ще
        </Button>
      </div>
    )}
  </div>
);
